module.exports = __webpack_public_path__ + "img/4 caroline-avila-circulo.700ec781.png";